/*
 * Author: Roger
 * File Created: Wednesday, 24-07-24 09:35 pm
 * Last Modified: Monday, 25-03-17 03:18 pm, by Harper Yan
 */

import { useRouter } from 'next/router';
import { i18n, useTranslation } from 'next-i18next';
import { Fade, List, ListItemButton, ListItemText, Slide, Stack } from '@mui/material';
import { Icon } from '@ucard/ds/Icon';
import useLanguage from '@/hooks/useLanguage';
import { StyledSubTitleText } from './style';
interface LanguageSwitcherProps {
  open: boolean;
  onClose: () => void;
  containerRef: Element | null;
  isXsScreen: boolean;
}
type LangProps = 'zh' | 'en';
export const LanguageSwitcher: React.FC<LanguageSwitcherProps> = ({
  open,
  onClose,
  containerRef,
  isXsScreen
}) => {
  const {
    t
  } = useTranslation('common');
  const router = useRouter();
  const currentLang = router.locale as LangProps;
  const {
    setLocale
  } = useLanguage();
  const handleSelect = async (lang: LangProps) => {
    setLocale(lang);
    onClose();
  };
  const content = <Stack bgcolor="#111217" height="100%" position="absolute" width="100%">
      <StyledSubTitleText mb={1} mt={2} px="20px" py={0.5}>
        {i18n?.t('header.language')}
      </StyledSubTitleText>
      <List>
        <ListItemButton onClick={() => {
        handleSelect('en');
      }}>
          <ListItemText primary={t('language.en')} primaryTypographyProps={{
          color: '#FFF'
        }} />
          {currentLang === 'en' && <Icon fontSize="inherit" htmlColor="white" name="Selected" sx={{
          fontSize: '20px'
        }} />}
        </ListItemButton>
        <ListItemButton onClick={() => {
        handleSelect('zh');
      }}>
          <ListItemText primary={t('language.zh')} primaryTypographyProps={{
          color: '#FFF'
        }} />
          {currentLang === 'zh' && <Icon fontSize="inherit" htmlColor="white" name="Selected" sx={{
          fontSize: '20px'
        }} />}
        </ListItemButton>
      </List>
    </Stack>;
  if (!isXsScreen) {
    return <Fade in={open} timeout={300}>
        {content}
      </Fade>;
  }
  return <Slide container={containerRef} direction="left" in={open} timeout={300} data-sentry-element="Slide" data-sentry-component="LanguageSwitcher" data-sentry-source-file="LanguageSwitcher.tsx">
      {content}
    </Slide>;
};